import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { SpinnerService } from 'src/app/services/spinner.service';
import { setConfigTable, setConfigTableModalBusqueda,timerOut } from 'src/app/shared/utils';

@Component({
  selector: 'app-modal-busqueda-articulos',
  templateUrl: './modal-busqueda-articulos.component.html',
  styleUrls: ['./modal-busqueda-articulos.component.css']
})
export class ModalBusquedaArticulosComponent implements OnInit {

  @Input() articulos: [];

  dtTrigger: Subject<null> = new Subject();
  dtOptions: any = {};
  position: number = 1;
  index: number = 0;

  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  constructor(
    private modalService: NgbActiveModal, 
    private spinnerService: SpinnerService
  ) { };

  ngOnInit(): void {

    this.position = 0;
    this.index = this.articulos.length - 1;
    this.dtOptions = setConfigTableModalBusqueda(false);
    timerOut(10).then((value: any) => {
      if (value) { this.codArticuloInput.nativeElement.focus(); }
    });
    setTimeout(() => {
      this.spinnerService.activarLoading(false);
    }, 500);
  }

  onClick(data: any): void {
    this.modalService.close(data);
  }

  cancelar(): void {
    this.modalService.dismiss('canceling');
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    let x = event.keyCode;

    if (this.articulos.length > 0) {
      if (x === 13) {//enter 13
        this.onClick(this.articulos[this.position])
      }

      if (x === 38) {//38 arriba
        if (this.position > 0) {
          this.position--;
          // console.log(this.position)
          // console.log(this.articulos[this.position])
        }
      }

      if (x === 40) {//40 abajo
        if (this.position < this.index) {
          this.position++;
          // console.log(this.articulos[this.position])
          // console.log(this.position)
        }
      }
    }
  }
  @ViewChild('codArticuloI') codArticuloInput: ElementRef;

  onNexFocus() {
    timerOut(10).then((value: any) => {
      if (value) { this.codArticuloInput.nativeElement.focus(); }
    });
  }
}
